import { RootState } from '@configurations/store';
import {
  DimensionName,
  DimensionSlug,
} from '@models/salesAttribution/dimensions';

type PayloadKeys =
  | 'incrementalSalesLift'
  | 'confidenceLevel'
  | 'incrementalSales'
  | 'transactionSizeSales'
  | 'transactionRateSales'
  | 'shopRateSales'
  | 'totalSales'
  | 'exposedSalesRate'
  | 'controlSalesRate'
  | 'exposedTransactionSize'
  | 'controlTransactionSize'
  | 'transactionSizeLift'
  | 'exposedTransactionRate'
  | 'controlTransactionRate'
  | 'transactionRateLift'
  | 'exposedShopRate'
  | 'controlShopRate'
  | 'shopRateLift';

type ReportPayload = { id: number; reportDate: string } & Record<
  PayloadKeys,
  {
    inStore: number | null;
    online: number | null;
    total: number | null;
  }
>;

type PayloadWithData = {
  status: 'available';
  reports: Record<number, ReportPayload>;
  hasDimensionData: boolean;
};

type ChannelName = 'ecommerce' | 'inStore' | 'total';
type SummaryFields = {
  dimensionValue: string;
  incrementalSalesLift: number;
  incrementalSales: number;
  totalSales: number;
};
type ContributionMetricsFields = {
  dimensionValue: string;
  incrementalSalesLift: number;
  incrementalSales: number;
  transactionSizeLift: number;
  transactionSize: number;
  transactionRateLift: number;
  transactionRate: number;
  penetrationLift: number;
  penetration: number;
};

type DimensionValues = Record<
  DimensionSlug,
  {
    summary: Record<ChannelName, SummaryFields[]>;
    contributionMetrics: Record<ChannelName, ContributionMetricsFields[]>;
  }
>;

export type DimensionPayload = Record<number, Partial<DimensionValues>>;

export type DimensionMenuPayload = Record<
  string,
  {
    menuText: DimensionName;
    apiSlug: DimensionSlug;
    total: number;
  }[]
>;

type PurchasedPayload = {
  status: 'purchased';
};
type PayloadWithoutData = { status: 'unavailable' };

export type Payload = PayloadWithData | PurchasedPayload | PayloadWithoutData;

export const selectCurrentReportDate = (state: RootState) =>
  state.dashboardSlice.ui.selectedReportDate;
